import { Image as ImageComponent } from 'antd'

export default function Image(props) {
  return <ImageComponent preview={false} {...props} />
}